// extracted by mini-css-extract-plugin
export var standaloneTable = "_p-0";
export var standaloneTableWithBodyFill = "_p-1";
export var withExtraHeader = "_p-2";